<template>
  <div id="container">
    <div v-show="!isShowNext">
      <div class="item-box-content" v-if="$route.query.type !== 'red'">
        <div class="title-font-style">
          <span>退票信息</span>
        </div>
        <el-form label-width="100px" style="margin-top:20px;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="退票原因：">
                <el-input v-model="mark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="item-box-content">
        <div class="title-font-style">
          <span>发票清单</span>
        </div>
        <el-table
          highlight-current-row
          style="margin-top:20px;"
          border
          @current-change="handleCurrentChange"
          :data="list"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          height="378"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column prop="invoiceCode" label="发票编号" width="120px"></el-table-column>
          <el-table-column prop="cusName" label="公司名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="amount" label="发票金额"></el-table-column>
          <el-table-column label="申请时间">
            <template slot-scope="scope">{{ scope.row.createDate | dateFilter }}</template>
          </el-table-column>
          <el-table-column prop="invoiceType" label="发票类型"></el-table-column>
          <el-table-column prop="bilingType" label="开票类型"></el-table-column>
          <el-table-column label="开票时间">
            <template slot-scope="scope">{{scope.row.invoiceDate | dateFilter}}</template>
          </el-table-column>
          <el-table-column prop="processSecUser" label="处理人"></el-table-column>
        </el-table>
      </div>
      <el-row style="margin:20px 20px">
        <el-col :span="24">
          <el-button @click="onNext" type="primary" v-if="$route.query.type === 'red'">下一步</el-button>
          <el-button @click="goBack" v-if="$route.query.type === 'red'">返回</el-button>
          <el-button @click="onApplyForReturnTicket" type="primary" v-else>申请退票</el-button>
        </el-col>
        <el-col :span="24" style="margin-top:16px;">
          <span v-if="$route.query.type === 'red'">单次仅允许对一张发票申请红字信息表</span>
          <span v-else>单次仅允许申请一张发票退回，请申请后尽快将未核销票据交至财务部</span>
        </el-col>
      </el-row>
    </div>
    <!---------------- 申请开红字发票-选择产品 ---------------->
    <red-bill-product v-show="isShowNext" ref="redBillProductRefs"></red-bill-product>
    <!-------------- 申请退票二次确认 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      title="确认退票"
      content="退票申请发起后不可撤回，是否确认退票？"
    ></open-or-close>
  </div>
</template>
<script>
import redBillProduct from './redBillProduct'
import OpenOrClose from '@/components/OpenOrClose/index'
import {
  queryStateByList,
  orderContractInvoiceSubAdd,
  applyForRefund,
  saleRefundTicket
} from '@/api/sell/sellManage'
export default {
  components: {
    'red-bill-product': redBillProduct,
    'open-or-close': OpenOrClose
  },
  data() {
    return {
      mark: '',
      list: [],
      obj: {}, // 选中的发票
      params: {},
      loadingTable: false,
      isShowNext: false
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      if (this.$route.query.oscId) {
        applyForRefund(this.$route.query.oscId,
          this.$route.query.type === 'red' ? 2 : 1
        ).then((res) => {
          if (res.data.code === 200) {
            this.params = res.data.obj
            this.list = res.data.obj.orderContractInvoices
          }
        })
      } else {
        queryStateByList(
          this.$route.query.id,
          this.$route.query.type === 'red' ? 2 : 1
        ).then((res) => {
          if (res.data.code === 200) {
            this.list = res.data.obj
          }
        })
      }
    },
    handleCurrentChange(val) {
      // 选中列
      this.obj = val
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    goBack() {
      window.history.back(-1)
    },
    onNext() {
      // 下一步
      if (!this.obj.id) {
        this.$message.error('请选择需要退票的发票！')
        return
      }
      this.$refs.redBillProductRefs.getList(this.obj)
      this.isShowNext = true
    },
    // 申请退票
    onApplyForReturnTicket() {
      if (!this.mark) {
        this.$message.error('请填写退票理由！')
        return
      }
      if (!this.obj.id) {
        this.$message.error('请选择需要退票的发票！')
        return
      }
      this.$refs.OpenOrCloseRefs.onInitial()
    },
    // 二次确认弹窗
    onUpdataState() {
      const obj = {
        ...this.obj,
        obId: this.obj.ocbId,
        ociId: this.obj.id,
        orderContractInvoiceSubContents: [],
        mark: this.mark,
        subType: 2
      }
      if (this.$route.query.oscId) {
        saleRefundTicket({
          orderContractInvoiceSubContentVo: obj,
          orderContractSalereturnGoods: this.params
            .orderContractSalereturnGoods
        }).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('已申请退票，请等待审核！')
            this.$router.push({
              name: 'sellSalesReturnEdit',
              query: {
                id: this.$route.query.oscId,
                cusId: this.$route.query.cusId
              }
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        orderContractInvoiceSubAdd(obj).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('已申请退票，请等待审核！')
            this.$router.push({
              name: 'contractEdit',
              query: {
                id: this.$route.query.id,
                cusId: this.$route.query.cusId
              }
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    }
  }
}
</script>
